import { createContext } from 'react'

import type { UseFileProviderReturn } from './use-file'

export type FileContext = Partial<UseFileProviderReturn>

export const FileContext = createContext<FileContext>({})
